import superagent from '@ott/superagent';

import cities from '../../dicts/citiesMetaInfo';

let cityInfoCacheCode;
let cityInfoCache;

export default async function getCityInfo(metaCode) {
  if (cityInfoCacheCode && cityInfoCacheCode === metaCode && cityInfoCache) {
    return cityInfoCache;
  }

  let result = {};

  try {
    const id = cities && cities[metaCode];

    if (!id) {
      return {};
    }

    const { body } = await superagent
      .get('https://www.onetwotrip.com/_hotels/api/objectRequest')
      .query({ id });

    result = body?.result || {};
  } catch (e) {
    cityInfoCacheCode = null;
    cityInfoCache = {};

    return cityInfoCache;
  }

  cityInfoCacheCode = metaCode;
  cityInfoCache = {
    city: result.name_ascii,
    country: result.country_code,
  };

  return cityInfoCache;
}
